// extracted by mini-css-extract-plugin
export default {"title":"_C0VA","qrCode":"aTatD"};